module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_06@2x-1e29ccc1fb8df66574e78f54144a2de9.jpg";